import { ApolloLink } from "apollo-link";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import ApolloClient from "apollo-client";

import { HubcappGraphqlQLError } from "@hubcapp/errors";

import { getAuthToken } from "../utils/auth";
import cache from "./cache";

const graphQLUri =
  window?._env_?.REACT_APP_GRAPHQL_URI || "http://localhost:4010/graphql";

const httpLink = createHttpLink({
  uri: graphQLUri,
});

const authLink = setContext(async (_, { headers }) => {
  const publicToken = localStorage.getItem("publicAuth");
  const instructorToken = localStorage.getItem("instructorAuth");
  const token = await getAuthToken();
  return {
    headers: {
      ...headers,
      authorization:
        instructorToken ??
        publicToken ??
        token ??
        window._env_.REACT_APP_initial_access_token_key,
      platform: "Hubcapp",
    },
  };
});

const errorLink = onError(({ graphQLErrors, response }) => {
  if (graphQLErrors && response) {
    response.errors = graphQLErrors.map(err => new HubcappGraphqlQLError(err));
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache,
});

export default client;
